var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseButtonV2,{staticClass:"create-button",attrs:{"variant":"outline","content-variant":_setup.getVariant},on:{"click":function($event){return _setup.emits('click')}}},[_c(_setup.SvgCreate,{staticClass:"create-button__icon"}),(_setup.getVariant === 'withIcon')?_c('span',[_vm._v("Создать")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }